import { createDialog } from '../../util/createDialog';

const dialog = createDialog();

/** @type {DialogFactory<{}>} */
export const $$blockingDialog = {
  ...dialog
};
